import React, { FC, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Button, Label, Textarea } from '../../atoms';
import cn from 'classnames';
import styles from './LandscapeAboutLandscapeTemplate.module.css';
import { EntityGalleryTileResponseDto } from '../../../store/landscapeAPI/galleryTile/dto/response/entity-gallery-tile-response.dto';
import { ImageContainer } from '../../molecules';
import LandscapeBaseEditTemplate from '../../../templates/LandscapeBaseEditTemplate';
import LandscapeAboutBaseEditTemplate from '../../../templates/LandscapeAboutBaseEditTemplate';
import { useNavigate, useParams } from 'react-router-dom';
interface LandscapeAboutLandscapeTemplateProps {
  galleryTiles: EntityGalleryTileResponseDto[];
  handleEdit: (id: string) => void;
  handleDelete: (id: string) => void;
}

const LandscapeAboutLandscapeTemplate: FC<
  LandscapeAboutLandscapeTemplateProps
> = ({ galleryTiles, handleEdit, handleDelete }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [content, setContent] = useState<string>('');
  return (
    <Container>
      <LandscapeBaseEditTemplate>
        <LandscapeAboutBaseEditTemplate>
          <div className={cn(styles.heading)}>
            <Label
              content="These blocks will be added to the general page of a landscape"
              size="lg"
            />
          </div>
          <Button
            variant="dark"
            onClick={() =>
              navigate(`/landscapes/edit/${id}/about/landscape/add`)
            }
          >
            Add Gallery Tile
          </Button>
          <div className={cn(styles.imagesWrapper)}>
            {galleryTiles.map((galleryTile, index) => (
              <ImageContainer
                src={galleryTile.blobUrl}
                key={index}
                handleEdit={() => handleEdit(galleryTile.id)}
                handleDelete={() => handleDelete(galleryTile.id)}
              />
            ))}
          </div>
          <div className={cn(styles.textAreaWrapper)}>
            <Textarea content={content} setContent={setContent} />
          </div>
        </LandscapeAboutBaseEditTemplate>
      </LandscapeBaseEditTemplate>
    </Container>
  );
};

export default LandscapeAboutLandscapeTemplate;
